import { gql, TypedDocumentNode } from '@apollo/client'
import { UpdateBackofficeUserDataInterface, UpdateBackofficeUserInputInterface } from './interfaces'

export const updateBackofficeUser: TypedDocumentNode<
  UpdateBackofficeUserDataInterface,
  UpdateBackofficeUserInputInterface
> = gql`
  mutation UpdateBackofficeUser($input: UpdateBackofficeUserInput!) {
    updateBackofficeUser(input: $input) {
      id
      mobileNumber
      firstname
      lastname
    }
  }
`

export default updateBackofficeUser
